import { render, staticRenderFns } from "./verificationCode.vue?vue&type=template&id=762d50fd"
import script from "./verificationCode.vue?vue&type=script&lang=js"
export * from "./verificationCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports